const variants = {
  langTabBgVariants: {
    type: "spring",
    stiffness: 200,
    damping: 17,
  },
}

export default variants;
